module.exports = __webpack_public_path__ + "main/assets/public/player-controls/volume-icon.842a4479d399933c.svg";